import BackupDeviceList from "../backup/backup.device.list";

const ImageDevice = () => <BackupDeviceList backupKind="image" />;

export default ImageDevice;
